// material
import { keyframes } from '@emotion/react'
import FeedbackIcon from '@mui/icons-material/Feedback'
import { Box, type BoxProps, Button } from '@mui/material'
import useCollapseDrawer from 'hooks/useCollapseDrawer'
// ----------------------------------------------------------------------

export default function FeedbackNav({ sx }: BoxProps) {
  // Define the ping animation
  const pingAnimation = keyframes`
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.02);
      opacity: 0.9;
    }
  `
  const { isCollapse } = useCollapseDrawer()
  return (
    <Box sx={{ height: 40, marginBottom: 2, display: 'flex', justifyContent: 'center', ...sx }}>
      {!isCollapse ? (
        <Button
          startIcon={<FeedbackIcon />}
          type="submit"
          variant="contained"
          onClick={() => {
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLSchj-JwVgH_kGxgqOKDbObXFHol-FTTr477cvGlBNTAzJghNw/viewform',
              '_blank'
            )
          }}
          sx={{
            fontStyle: 'italic',
            padding: '5px 20px',
            width: { xs: '95%', sm: '95%' },
            animation: `${pingAnimation} 2s infinite`
          }}
        >
          Gửi Ý Kiến Đóng Góp! (v1.3)
        </Button>
      ) : (
        <Button
          type="submit"
          variant="contained"
          onClick={() => {
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLSchj-JwVgH_kGxgqOKDbObXFHol-FTTr477cvGlBNTAzJghNw/viewform',
              '_blank'
            )
          }}
          sx={{
            fontStyle: 'italic',
            padding: '5px 2px',
            width: { xs: '50%', sm: '50%' },
            animation: `${pingAnimation} 2s infinite`
          }}
        >
          <FeedbackIcon />
        </Button>
      )}
    </Box>
  )
}
